import { useMemo } from 'react';

import { EvolutionArrowDirection } from '../../DeltaValueHeader/types';

export function useArrowDirection(
  delta: number | null,
): EvolutionArrowDirection {
  return useMemo(() => {
    let direction: EvolutionArrowDirection | null = null;

    if (delta === 0) {
      direction = 'right';
    }

    if (delta && delta > 0) {
      direction = 'up';
    }

    if (delta && delta < 0) {
      direction = 'down';
    }

    return direction || 'right';
  }, [delta]);
}
